<div class="modulo">
    <!--<app-header [tituloModulo]="titulo" [mostrarCrear]="false" [accion]="accion" [id]="id" [raiz]="'/actividades'" [regresar]="'/actividades'"></app-header>-->
</div>